import { useEffect } from 'react';
import { nouveautesPour, marquerVues, versionPlusRecente, derniereVue } from '../nouveautes';
import { APP_VERSION } from '../version';

/** Fenêtre « Quoi de neuf » : les évolutions récentes, filtrées selon le rôle. */
export default function Nouveautes({ role, onFermer }) {
  const vueAvant = derniereVue();
  const liste = nouveautesPour(role).slice(0, 8);
  useEffect(() => { marquerVues(APP_VERSION); }, []);
  useEffect(() => {
    const esc = e => e.key === 'Escape' && onFermer();
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [onFermer]);

  return (
    <div role="dialog" aria-modal="true" aria-label="Quoi de neuf" onClick={e => e.target === e.currentTarget && onFermer()}
         style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.65)', zIndex:4000, display:'flex',
                  alignItems:'flex-end', justifyContent:'center', padding:12 }}>
      <div style={{ background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:16, width:'100%', maxWidth:500,
                    maxHeight:'82vh', display:'flex', flexDirection:'column', marginBottom:'env(safe-area-inset-bottom, 0px)' }}>
        <div style={{ padding:'18px 18px 12px', borderBottom:'1px solid var(--border)', display:'flex', alignItems:'center', gap:10 }}>
          <div style={{ flex:1 }}>
            <div style={{ fontFamily:'Barlow Condensed', fontSize:22, fontWeight:800 }}>✨ Quoi de neuf</div>
            <div style={{ fontSize:12, color:'var(--muted)', marginTop:2 }}>Version installée : {APP_VERSION}</div>
          </div>
          <button onClick={onFermer} aria-label="Fermer"
                  style={{ background:'none', border:'none', color:'var(--muted)', fontSize:22, cursor:'pointer', lineHeight:1 }}>×</button>
        </div>
        <div style={{ overflowY:'auto', padding:'6px 18px 18px' }}>
          {liste.map((v, i) => {
            const nouveau = !vueAvant || versionPlusRecente(v.version, vueAvant);
            return (
              <div key={v.version} style={{ paddingTop:14, marginTop: i ? 4 : 0, borderTop: i ? '1px solid var(--border)' : 'none' }}>
                <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:8 }}>
                  <span style={{ fontSize:12, fontWeight:800, color:'var(--accent)', letterSpacing:1 }}>VERSION {v.version}</span>
                  {nouveau && vueAvant && <span style={{ fontSize:9.5, fontWeight:800, color:'var(--accent-text)', background:'var(--accent)',
                                                        borderRadius:4, padding:'1px 6px', letterSpacing:.5 }}>NOUVEAU</span>}
                </div>
                {v.points.map((p, k) => (
                  <div key={k} style={{ display:'flex', gap:10, fontSize:13.5, lineHeight:1.55, marginBottom:8 }}>
                    <span aria-hidden="true" style={{ flexShrink:0 }}>{p.icone}</span>
                    <span>{p.texte}</span>
                  </div>))}
              </div>);
          })}
        </div>
      </div>
    </div>
  );
}
